import { isDev } from "@fuse/utils/DeviceDection"

// API URL based on environment
export const API_URL = isDev()
  ? import.meta.env.VITE_API_URL_DEV ||
    "http://localhost:5001/letshang-dev/us-central1/api/v2"
  : import.meta.env.VITE_API_URL_PROD || "https://api.letshang.co/v2"

// Social media links
export const INSTAGRAM_URL = "https://www.instagram.com/letshang.app/"
export const TWITTER_URL = "https://twitter.com/letsHangApp"
export const FACEBOOK_URL = "https://www.facebook.com/letshangapp"

// App links
export const APP_STORE_URL =
  "https://apps.apple.com/us/app/letshang/id1547911833"
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=co.letshang.app"

// Main website URL
export const WEBSITE_URL = isDev()
  ? "http://localhost:5173"
  : "https://letshang.co"

export enum EFailureMessage {
  JoinedEvent = "Something went wrong, please try again",
  CommonMessage = "Something went wrong, please try again.",
  UnableToJoinGroup = "Unable to join group",
  UnableToLeaveGroup = "Unable to leave group",
  UnableToCreateMixemup = "Oops! Something went wrong. Please try again.",

  AddQuestionnairesFail = "Unable to add Questionnaires",
  UnableToConnectWithStripe = "Unable To Connect With Stripe!",
  UserAlreadyConnectWithStripe = "User account already connected!",

  AddTicketsFail = "Unable to add Ticket!",
  UpdateTicketsFail = "Unable to update Ticket!",

  CreateEvent = "Uh-oh! Something went wrong, please try again.",
}
